import React from 'react';
import PropTypes from 'prop-types';
import HouseholdSectionPicker
  from 'Components/Flyouts/HouseholdInfo/Sections/Section/HouseholdSectionPicker/HouseholdSectionPicker';
import HouseholdSectionMemberPicker from './HouseholdSectionMemberPicker/HouseholdSectionMemberPicker';

const ServiceSection = ({ householdResource }) => {
  return (
    <HouseholdSectionPicker label="Member" resource={householdResource}>
      <HouseholdSectionMemberPicker resource={householdResource} />
    </HouseholdSectionPicker>
  );
};

ServiceSection.propTypes = {
  householdResource: PropTypes.object.isRequired,
};

export default ServiceSection;
